import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import { useLoading } from '../../../../context/LoadingContext';
import Requirements from "./RequirementTab";

// import IndicativeOffers from "./IndicativeOffersTab";

import ReqShortlistedOffers from "./ShortlistedOffers";


const GPRequirementModule = () => {
    const [activeUser, setActiveUser] = useState("");
    const [activeTab, setActiveTab] = useState("Requirements");
    const { setLoading } = useLoading();
    const navigate = useNavigate();

    const tabs = ["Requirements", "Shortlisted Offers"];

    useEffect(() => {
        const checkUser = async () => {
            try {
                const user = await Auth.currentAuthenticatedUser();
                const token = user.signInUserSession.idToken.jwtToken;
                const decodedToken = jwtDecode(token);
                const groups = decodedToken["cognito:groups"] || [];
                if (!groups.includes("AMTPL_GLOBAL_PARTNERS")) {
                    await Auth.signOut();
                    navigate("/login/global-partner");
                } else {
                    setActiveUser(user.attributes.email);
                }
            } catch (error) {
                await Auth.signOut();
                navigate("/login/global-partner");
            }
        };
        checkUser();
    }, [navigate]);

    const renderTabContent = () => {
        switch (activeTab) {
            case "Requirements":
                return <Requirements />;
            case "Shortlisted Offers":
                return <ReqShortlistedOffers />;
            default:
                return <Requirements />;
        }
    };

    return (
        <div className="buyer-layout">
            <div className="amtpl-tabs">
                <div className="content3">
                    <main className="main-content">
                        <div className="main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${
                                        activeTab === tab
                                            ? "active"
                                            : "notactive"
                                    }`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default GPRequirementModule;